import { Capacitor, registerPlugin } from '@capacitor/core';

export type ApkInstallerPlugin = {
  canInstall: () => Promise<{ allowed: boolean }>;
  openInstallSettings: () => Promise<void>;
  install: (options: { path: string }) => Promise<void>;
};

const ApkInstaller = registerPlugin<ApkInstallerPlugin>('ApkInstaller');

export function isAndroidNativeRuntime(): boolean {
  return Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android';
}

export async function installApkFromPath(path: string): Promise<void> {
  await ApkInstaller.install({ path });
}

export async function canInstallApk(): Promise<boolean> {
  const { allowed } = await ApkInstaller.canInstall();
  return allowed;
}

export async function ensureApkInstallPermission(): Promise<boolean> {
  if (await canInstallApk()) return true;
  await ApkInstaller.openInstallSettings();
  return false;
}
